import React from "react";

export function capitalize(str: string): string {
  return str
    .split(" ")
    .map((text) => {
      if (text.length > 0) {
        return text[0].toUpperCase() + text.substring(1).toLowerCase();
      } else {
        return "";
      }
    })
    .join(" ");
}

export const Title = ({ text, ...rest }: any) => {
  return <span {...rest}>{capitalize(text)}</span>;
};
